__turbopack_context__.v({
  "badge": "open-chat-button-module-scss-module__rLF3Mq__badge",
  "bounceInUp": "open-chat-button-module-scss-module__rLF3Mq__bounceInUp",
  "button": "open-chat-button-module-scss-module__rLF3Mq__button",
  "button--hide": "open-chat-button-module-scss-module__rLF3Mq__button--hide",
  "button__min": "open-chat-button-module-scss-module__rLF3Mq__button__min",
  "iconButton": "open-chat-button-module-scss-module__rLF3Mq__iconButton",
  "iconButton--hide": "open-chat-button-module-scss-module__rLF3Mq__iconButton--hide",
  "iconButton__text": "open-chat-button-module-scss-module__rLF3Mq__iconButton__text",
  "icon_text": "open-chat-button-module-scss-module__rLF3Mq__icon_text",
  "text": "open-chat-button-module-scss-module__rLF3Mq__text",
  "text__inner": "open-chat-button-module-scss-module__rLF3Mq__text__inner",
  "tooltip": "open-chat-button-module-scss-module__rLF3Mq__tooltip",
});
